export default __webpack_public_path__ + "static/media/report_reca.ee0980d6.svg";